/* eslint-disable react/no-danger */
import React, { useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';
import purify from '../../helpers/domPurifierHelper';
import styles from './StudyIntro.module.scss';
import Title from '../Title/Title';
import { Study } from '../../typings/types';

type StudyIntroProps = {
  study: Study;
};

const StudyIntro: React.FC<StudyIntroProps> = ({ study }: StudyIntroProps) => {
  const cleanIntro = purify(study.intro);
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const [overflow, setOverflow] = React.useState(false);
  const [height, setHeight] = React.useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const maxHeight = lineHeight * 8;

      setOverflow(el.scrollHeight > maxHeight);
      setHeight(lineHeight * 4);
    };

    measure();
    window.addEventListener('resize', measure);

    return () => window.removeEventListener('resize', measure);
  }, [cleanIntro]);

  if (!overflow) {
    return (
      <>
        <Title>{study?.title}</Title>
        <div className={styles.introContainer}>
          <div
            className={classNames('wrap-words', styles.introText)}
            dangerouslySetInnerHTML={{ __html: cleanIntro }}
            ref={ref}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <Title>{study?.title}</Title>
      <div className={styles.introContainer}>
        <div
          ref={ref}
          id="study-intro"
          className={classNames('wrap-words', styles.introText, {
            [styles.open]: open,
            [styles.overflow]: overflow,
          })}
          style={!open ? { maxHeight: height, overflow: 'hidden' } : undefined}
          dangerouslySetInnerHTML={{ __html: cleanIntro }}
        />
        <button
          className={classNames(
            'button button-secondary',
            styles.readMoreButton,
            { [styles.open]: open }
          )}
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          aria-expanded={open}
          aria-controls="study-intro"
        >
          {open ? 'Näytä vähemmän' : 'Näytä lisää'}
        </button>
      </div>
    </>
  );
};

export default StudyIntro;
